import { Injectable, signal } from '@angular/core';
import { SuiteGroupModel } from '../shared/models/suite-group.model';

@Injectable({ providedIn: 'root' })
export class SuiteGroupStore {
  private readonly _suiteGroups = signal<SuiteGroupModel[]>([]);
  private readonly _selectedSuiteGroup = signal<SuiteGroupModel | null>(null);

  readonly suiteGroups = this._suiteGroups.asReadonly();
  readonly selectedSuiteGroup = this._selectedSuiteGroup.asReadonly();

  setSuiteGroups(suiteGroups: SuiteGroupModel[]) {
    this._suiteGroups.set([...suiteGroups]);
  }

  setSelected(suiteGroup: SuiteGroupModel | null) {
    this._selectedSuiteGroup.set(suiteGroup);
  }

  /** Idempotent by id: the server's FacilitySuiteGroups broadcast can land before the create response, so the group may already be here. */
  addSuiteGroup(suiteGroup: SuiteGroupModel) {
    this._suiteGroups.update((suiteGroups) => {
      const alreadyPresent = suiteGroups.some((g) => g.id === suiteGroup.id);

      if (alreadyPresent) {
        return suiteGroups;
      }

      return [...suiteGroups, suiteGroup];
    });
  }

  updateSuiteGroup(updated: SuiteGroupModel) {
    this._suiteGroups.update((suiteGroups) =>
      suiteGroups.map((g) => (g.id === updated.id ? updated : g))
    );
  }

  removeSuiteGroup(id: Guid) {
    this._suiteGroups.update((suiteGroups) => suiteGroups.filter((g) => g.id !== id));
  }
}
